import React from 'react';
import './App.css';

/**
 * Debounce functions for better performance
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Function} fn The function to debounce
 */
const debounce = function (fn, t) {

	// Setup a timer
	var timeout;

	// Return a function to run debounced
	return function () {

		// Setup the arguments
		var context = this;
		var args = arguments;

		// If there's a timer, cancel it
		if (timeout) {
			clearTimeout(timeout);
		}

		// Setup the new requestAnimationFrame()
		timeout = setTimeout(function () {
			fn.apply(context, args);
		}, t||100);

	}

};


const https = require('https');
const csv = require('csv-parser');
/*
ORG / SPACE NAME,NEIGHBORHOOD,MAP SECTION (approx.),Archive + Reference,"Broadcast + \nCommunications",Commercial Gallery,Community Outreach,Experimental Space,Gallery,Moving Image,Museum,Performance Org,Performance Venue,Production + Services,Public Space,Retail,Studio + Instruction,Timed Events,May Require Appointment ,Ticket or Admission Fee Required,INSTAGRAM @,WEBSITE ,ADDRESS,ZIP
*/
const possibleDescriptors = [
	"Archive + Reference",
	"Broadcast + Editorial",
	"Commercial Gallery",
	"Community Outreach",
	"Experimental Space",
	"Gallery",
	"Moving Image",
	"Museum",
	"Performance Org",
	"Performance Venue",
	"Production + Services",
	"Public Space",
	"Retail",
	"Studio + Instruction",
	"Timed Events"
];
const cols = {
	name: 'ORG / SPACE NAME',
	//_descriptors: 'DESCRIPTORS AT-A-GLANCE',
	address: 'ADDRESS',
	website: 'WEBSITE ',
	neighborhood: 'NEIGHBORHOOD',
	requiresAppointment: 'May Require Appointment ',
	entryFee: 'Ticket or Admission Fee Required',
	instagram: 'INSTAGRAM @'
};
const url = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQNu26JlgN3RZU_rB-IGFw1e4412tgzAxqo4BMnk1_Masj7HY7PqrBJEMtdY_jFOfRkc-VTtPVp0oxZ/pub?output=csv';
const objKeys = (o) => Object.entries(o).map(([k,v]) => k).filter(x => !!x).sort();

const ExtraInfo = ({entryFee, requiresAppointment}) => (
	(entryFee || requiresAppointment) &&
	(<div className="mt-3">
		{entryFee && (<span className="badge badge-secondary mr-2 p-1">&#x26A0; entry fee</span>)}
		{requiresAppointment && (<span className="badge badge-secondary p-1">&#x26A0; appointment required</span>)}
	</div>)
);

const DescriptorLabel = ({name, handleClick}) => (
	// eslint-disable-next-line
	<a href="#" key={name} className="badge badge-info p-1 mr-1" data-filter-value={name} onClick={handleClick}>{name}</a>
);

const DescriptorLabels = ({descriptors,handleClick}) => (
	<div>
		{descriptors.map(
			(name) => DescriptorLabel({name: name, handleClick: handleClick})
		)}
	</div>
);

const AddressLink = ({address}) => (
	!!address && (address !== "Various") && (
		<div>
			<a rel="noopener noreferrer" target="_blank" href={"https://www.google.com/maps/place/"+encodeURIComponent(address)}>
				{address}
			</a>
		</div>
	)
);

const NeighborhoodLink = ({neighborhood, handleClick}) => (
	!!neighborhood && (
		<div>
			<a href="#" className="font-weight-bold text-reset" data-filter-value={neighborhood} onClick={handleClick}>{neighborhood}</a>
		</div>
	)
);

const SpaceNameLink = ({name, website}) => (
	website
		? (<a rel="noopener noreferrer" target="_blank" href={encodeURI(website)}>{name}</a>)
		: name
);

// TODO support #tag with:
// https://www.instagram.com/explore/tags/{TAG}/
const InstagramLink = ({instagram}) => (
	instagram &&
		(<div className="mt-3" style={{fontSize: "90%"}}>
			<span className="mr-1 font-weight-bold">Instagram:</span><a target="_blank" rel="noopener noreferrer" href={"https://www.instagram.com/"+encodeURIComponent(instagram)+"/"} className="no-text-decoration">
				{instagram.startsWith("#") ? instagram : "@"+instagram}
			</a>
		</div>)
);

const SpaceCard = ({address, descriptors, handlers, name, neighborhood, website, instagram, entryFee, requiresAppointment}) => (
	<div className="col-xl-4 col-lg-6 col-xs-12">
		<div className="card shadow-sm mb-4">
			<div className="card-body">
				<h5 className="card-title">
					<SpaceNameLink name={name} website={website} />
				</h5>
				<DescriptorLabels
					descriptors={descriptors}
					handleClick={handlers.descriptor.click} />
				<div className="card-text mt-2">
					<NeighborhoodLink
						neighborhood={neighborhood}
						handleClick={handlers.neighborhood.click} />
					<AddressLink address={address} />
					<InstagramLink instagram={instagram} />
					<ExtraInfo entryFee={entryFee} requiresAppointment={requiresAppointment} />
				</div>
			</div>
		</div>
	</div>
);

const Spaces = ({loaded, handlers, spaces}) => {
	if (!loaded) {
		return (<div>Loading something, wait a bit then try reloading...</div>)
	}
	if (spaces.length === 0) {
		return (<div>Sorry, nothing matches those filters</div>)
	}
	return (<div className="container-fluid">
		<div className="row">{
			spaces.map((x) => (
					<SpaceCard
						{...x}
						key={x.name}
						name={x.name}
						website={x.website}
						address={x.address}
						descriptors={x.descriptors} 
						neighborhood={x.neighborhood}
						handlers={handlers} />))
		}</div></div>)
};

const simpleOptions = (xs) => (
	xs.map((x) => (
		<option key={x} value={x}>{x}</option>
	))
);

const FilterDropdown = ({handleChange, label, labelWidth, selectOptions, selectedOption}) => {
	labelWidth = labelWidth || 3;
	return (
		<div className="row form-group">
			<label className={"font-weight-bold col-sm-3 col-xl-"+labelWidth+" mt-1"}>{label}</label>
			<select className={"col-sm-9 col-xl-"+(12-labelWidth)+" form-control"}
					onChange={handleChange}
					value={selectedOption}>
				<option value="">ANY</option>
				{simpleOptions(selectOptions)}
			</select>
	</div>);
};

const FilterOptions = ({handlers,expandFilters,filters,descriptors,neighborhoods}) => (
	<div className={"row"+(expandFilters ? "" : " d-none")}>
		<div className="col-xl-6">
			<FilterDropdown
				label="Category"
				handleChange={handlers.descriptor.change}
				selectOptions={descriptors}
				selectedOption={filters.descriptor} />
		</div>
		<div className="col-xl-6">
			<FilterDropdown
				label="Neighborhood"
				handleChange={handlers.neighborhood.change}
				selectOptions={neighborhoods}
				selectedOption={filters.neighborhood} />
		</div>
		<div className="col-xl-6">
			<div className="row form-group">
				<label className="font-weight-bold col-sm-3 mt-1">Contains</label>
				<input id="containsField" className="col-sm-9 form-control" onChange={handlers.search.change} />
			</div>
		</div>
	</div>
);

const TopBar = (props) => (
	<div className="sticky-top mt-3 mb-3 container-fluid" style={{backgroundColor: "#f8f8f8", borderBottom: "1px solid #ccc"}}>
		<div className="row p-2">
			<div className="col-7 pt-1 align-middle text-left">
				<a href="#" onClick={props.handlers.about.click} ><img src="HYMI_HORIZONTAL.png" style={{height: "24px"}} alt="Hey You Made It!" /></a>
			</div>
			<div className="col-5 text-right align-middle">
				{props.showAbout
					?
					<a className="btn btn-secondary btn-sm" href="#" onClick={props.handlers.about.click}>Back to the list</a>
					:
					<a className="btn btn-secondary btn-sm" href="#" role="button" onClick={props.handlers.expandFilters.click}>Filters {props.expandFilters ? <span>&#x2717;</span> : "+"}</a>}
			</div>
		</div>
		<div className={props.showAbout ? "d-none" : ""}>
			<FilterOptions {...props} />
		</div>
	</div>
);

const Glossary = (props) => (
<div style={{marginTop: "10em", marginBottom: "2em"}}>
	<h5>CATEGORY GLOSSARY:</h5>

<h6 className="mt-4 font-weight-bold">Archive + Reference</h6>
<p>
specialized, unusual, and/or historically significant archives, libraries, research collections, and other records of reference.
</p>

<h6 className="mt-4 font-weight-bold">Broadcast + Editorial</h6>
<p>
journalism, publishing + publications, podcasts, blogs, news agencies, critical reviews, brands, and other digital/online/multimedia communication outlets.
</p>

<h6 className="mt-4 font-weight-bold">Commercial Gallery</h6>
<p>
white cube exhibition spaces with curated, planned exhibition schedules that are sustained as art commercial ventures: representing, promoting, and routinely exhibiting a stable of selected artists. regularly engaged with art market collectors and dealers.
</p>

<h6 className="mt-4 font-weight-bold">Community Outreach</h6>
<p>
organizations or collectives whose programming and/or mission expressly and actively seeks inclusion and support for local, regional, outlier, underrepresented, at-risk, or vulnerable social groups and demographics.
</p>

<h6 className="mt-4 font-weight-bold">Experimental Space</h6>
<p>
independent (typically DIY - Do It Yourself) spaces borrowing exhibition and curatorial elements from conventional galleries and commercial galleries. includes apartment galleries, storefronts, and unconventional, ambulatory, or temporary locations (i.e. closets, boxes, purses, ears, vehicles, street poles, etc). programming can be subject to interruption with little/no advanced notice given.
</p>

<h6 className="mt-4 font-weight-bold">Gallery</h6>
<p>
general term for white cube exhibition spaces with curated, planned exhibition schedules.
</p>

<h6 className="mt-4 font-weight-bold">Moving Image</h6>
<p>
spaces promoting the moving image: independent cinema, theaters and screening rooms, movie festivals and premieres, video rentals, arthouse films, digital and experimental media.
</p>

<h6 className="mt-4 font-weight-bold">Museum</h6>
<p>
established historical, cultural, and/or research institutions or institutional affiliations (with museums, universities, foundations, government agencies) regularly featuring a calendar of significant high profile exhibitions, events, educational programming, or scheduled tours.
</p>

<h6 className="mt-4 font-weight-bold">Performance Org</h6>
<p>
troupes, companies, or collectives focused on live performance, live music, ambulatory performance, or experimental performance.
</p>

<h6 className="mt-4 font-weight-bold">Performance Venue</h6>
<p>
spaces that host/accommodate live performance including: poetry, literature, and other oratorical reading; durational and site-specific experimental performance; dance and choreography; sonic art; theater and stage; improv/standup; DJs; dancefloors; live music venues.
</p>

<h6 className="mt-4 font-weight-bold">Production + Services</h6>
<p>
paid professional organizations or individuals offering project services ranging from equipment rentals; formatting and printing; material fabrication; editing; consulting and advising; design identity; or facility access.
</p>

<h6 className="mt-4 font-weight-bold">Public Space</h6>
<p>
sites of public installation, activity, and interventions including street level engagement, architectural interiors and structures, parks, nature reserves, outdoor venues, transit routes, and other public thoroughfares not exclusively defined as or limited to art spaces.
</p>

<h6 className="mt-4 font-weight-bold">Retail</h6>
<p>
noteworthy or unusual stores, boutiques, shops, auction houses, or other commercial outlets for purchasing goods, wares, consumables, or materials.
</p>

<h6 className="mt-4 font-weight-bold">Studio + Instruction</h6>
<p>
offering studios, artist residencies, and other resources for artist development, material production, and skill building. can include classes, workshops, lectures, and other educational programming.
</p>

<h6 className="mt-4 font-weight-bold">Timed Events</h6>
<p>
timed, seasonal programming promoted as a prescheduled event, festival, fair, convention, biennial, or other distinct special viewing.
</p>
</div>
);
const About = (props) => (
<div style={{maxWidth: "540px", marginLeft: "auto", marginRight: "auto", marginBottom: "20em"}}>
	<div><img src="HYMI_STACKED.png" style={{maxWidth: "153px"}} /></div>
	<h5 className="mb-4">An experiment in navigating<br />arts spaces and interesting places<br />in and around Chicago.</h5>
	<p>
	Hey, you made it! I’m&nbsp;Q.&nbsp;(he/him)
	</p>
	<p>
	For your perusal is a directory of interesting, weird, important, and noble spaces
	and organizations that I, or humans I adore and respect, have been fortunate to come
	across in the years we’ve lived in Chicago. This began as a list of artists-run spaces,
	but has grown to include a range of categories directly and indirectly connecting Chicago
	arts and cultural communities. I hope this serves as a useful compass in helping you
	navigate back to some of those places you’re already familiar with, or maybe stumble
	across something new.
	</p>
	<p>
	Follow <a rel="noopener noreferrer" target="_blank" href="https://instagram.com/heyyoumadeit">@heyyoumadeit</a> on IG, where I'll post or repost reminders about upcoming events as often as I can.
	Of course, any project on this scale will have things left out, and in time, will need
	updates, corrections, additions and removals. So feel free to write
	to <a href="mailto:heyyoumadeit@gmail.com">heyyoumadeit@gmail.com</a> with any comments.
	</p>
	<p><span className="font-weight-bold" style={{textDecoration: "underline"}}>Please be
	patient and kind.</span> I’m one person, voluntarily sharing things I see, with anyone interested in looking. I&nbsp;can’t&nbsp;be&nbsp;everywhere (really,&nbsp;I&nbsp;can’t).
	</p>
	<p>
	Have a good time out there! And if you see me around, say hi.
	</p>
	<hr style={{width: "25%"}} className="mt-4 mb-4" />
	<p>
	About me: I’m an artist, arts administrator, and aesthetic supporter. Grew&nbsp;up&nbsp;in&nbsp;LA and Las Vegas. Reside in Chicago.<br />IG: <a rel="noopener noreferrer" target="_blank" href="https://instagram.com/greetings_q">@greetings_q</a>
	</p>
	<p>
	I work at <a rel="noopener noreferrer" target="_blank" href="http://saic.edu">SAIC</a> and volunteer with <a rel="noopener noreferrer" target="_blank" href="https://acreresidency.org">ACRE</a>. Obviously my views don’t necessarily reflect those of either, but they’re both important enough to me to mention&nbsp;here.
	</p>
	<hr style={{width: "25%"}} className="mt-4 mb-4"  />
	<p>
	Web interface credit and infinite gratitude to Brian&nbsp;Kirkbride.<br />
	Check out his work at <a rel="noopener noreferrer" target="_blank" href="https://internalsummer.com">internalsummer.com</a><br />
	IG: <a rel="noopener noreferrer" target="_blank" href="https://instagram.com/brian_kirkbride">@brian_kirkbride</a><br />
	Also: <a rel="noopener noreferrer" target="_blank" href="https://instagram.com/otherpeoplespixels">@otherpeoplespixels</a>
	</p>
	<hr style={{width: "25%"}} className="mt-4 mb-4"  />
	<p>
	Logo/avatar typeface: Moon by Jack&nbsp;Harvatt.
	</p>
	<Glossary />
	</div>
);

class App extends React.Component {
	handleRow(ds, ns, r) {
		const space = {};
		if (!r) { return }
		//console.log(objKeys(r));
		Object.entries(cols).forEach(([k,v]) => { space[k] = r[v].trim() });
		//console.log('space='+JSON.stringify(space));
		space.descriptors = possibleDescriptors.filter((k) => !!r[k]).sort();
/*
		CONSOLIDATED DESCRIPTOR FIELD PARSING
		space.descriptors =
			(space._descriptors||"")
			.split(/;/)
			.map(d => d.trim());
*/
		space.descriptors.forEach(d => ds[d] = 1);
		ns[space.neighborhood] = 1;
		space.instagram = space.instagram.replace(/^@/,'');
		//console.log('space='+JSON.stringify(space));
		return space;
	}

	constructor(props) {
		var _this;
		super(props);
		_this = this;
		this.state = {
			showAbout: false,
			expandFilters: false,
			filters: {},
			spaces: [],
			descriptors: [],
			neighborhoods: []
		};
		this.debouncedSetState = debounce(this.setState);
		https.get(url, (res) => {
			const statusCode = res.statusCode, ds = {}, ns = {}, ss = [];
			if (statusCode !== 200) {
				console.error('Failed HTTP request for '+url+': status code '+statusCode);
				return;
			}

			res.pipe(csv({ skipLines: 0 }))
			.on('data', (r) => { ss.push(_this.handleRow(ds, ns, r)); })
			.on('end', () => {
				const sortedSpaces = ss.sort((a,b) => {
					const an = a.name.toUpperCase(), bn = b.name.toUpperCase();
					if (an < bn) { return -1; }
					if (an > bn) { return 1; }
					return 0;
				});
				_this.setState({
					loaded: true,
					spaces: sortedSpaces,
					descriptors: objKeys(ds),
					neighborhoods: objKeys(ns)
				});
			});
		});
	}

	handleFilterChange(f, e) {
		const v = e.target.value || e.target.dataset.filterValue || "";
		//console.log("Set "+f+" to '"+v+"'");
		this.debouncedSetState((state,_) => {
			const stateChange = {
				filters: state.filters,
			};
			stateChange.filters[f] = v;
			if (!!v) {
				stateChange.expandFilters = true;
			}
			return stateChange;
		});
		e.preventDefault();
		e.stopPropagation();
		return false;
	}

	handleDescriptorChange(e) {
		return this.handleFilterChange('descriptor', e);
	}

	handleNeighborhoodChange(e) {
		return this.handleFilterChange('neighborhood', e);
	}

	handleSearchChange(e) {
		return this.handleFilterChange('search', e);
	}

	handleExpandFiltersClick(e) {
		this.setState((state,_) => ({expandFilters: !state.expandFilters}));
		e.preventDefault();
		e.stopPropagation();
		return false;
	}

	handleAboutClick(e) {
		this.setState((state,_) => ({showAbout: !state.showAbout}));
		e.preventDefault();
		e.stopPropagation();
		return false;
	}

	filterSpaces() {
		const fs = this.state.filters;
		const filterS = (fs.search||'').toUpperCase();
		const filterD = fs.descriptor;
		const filterN = fs.neighborhood;
		return this.state.spaces.filter((x) => (
			(!filterD || x.descriptors.includes(filterD)) &&
			(!filterN || x.neighborhood === filterN) &&
			(!filterS || x.name.toUpperCase().includes(filterS))
		));
	}

	render() {
		const spaces = this.filterSpaces();
		const dHandler = this.handleDescriptorChange.bind(this);
		const sHandler = this.handleSearchChange.bind(this);
		const nHandler = this.handleNeighborhoodChange.bind(this);
		const eHandler = this.handleExpandFiltersClick.bind(this);
		const aHandler = this.handleAboutClick.bind(this);
		const handlers = {
			about: { click: aHandler },
			expandFilters: { click: eHandler },
			search: { change: sHandler },
			descriptor: { change: dHandler, click: dHandler },
			neighborhood: { change: nHandler, click: nHandler }
		};
		return (
			<div className="App container-fluid" style={{width: "90%"}}>
				<TopBar
					showAbout={this.state.showAbout}
					handlers={handlers}
					filters={this.state.filters}
					expandFilters={this.state.expandFilters}
					neighborhoods={this.state.neighborhoods}
					descriptors={this.state.descriptors} />
				{this.state.showAbout
					?
					<About handlers={handlers} />
					:
					<Spaces handlers={handlers} spaces={spaces} loaded={this.state.loaded} />
				}
			</div>
		);
	}
}

export default App;
